import React from "react";
import NumberFormat from "react-number-format";
import appStyles from "../../../../app.module.css";

const PriceFormat = (props) => {
	return (
		<NumberFormat
			value={props.value}
			thousandSeparator={true}
			decimalScale={2}
			fixedDecimalScale={true}
			prefix={props.prefix || "$"}
			displayType="text"
			className={`${props.colorClass || appStyles.colorDarkGrey} ${
				props.priceWeightClass || ""
			} ${appStyles.textRight}`}
		/>
	);
};

export default PriceFormat;
